module.exports = __webpack_public_path__ + "img/Diamond1.2bf331ea.jpg";